module.exports = __webpack_public_path__ + "img/ideation_1.34106676.png";